/* ============================================================
   BASICARE — ヘッダーの検索パネル開閉

   カンプでは検索アイコンだけが置かれ、動作は未実装でした。
   Shopify の検索ページ（/search）へ送るパネルとして実装しています。

   モバイルメニューの開閉は sky.js 側が担当します。
   ============================================================ */
(function () {
  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;

      /* 閉じているあいだはフォーカスも読み上げも通さない。
         CSS の visibility ではなく inert で行う理由は store.css のコメント参照。 */
      function setOpen(open) {
        panel.classList.toggle('open', open);
        panel.inert = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var input = panel.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      }

      setOpen(false); /* 初期状態を明示（inert を付ける） */

      btn.addEventListener('click', function () {
        setOpen(!panel.classList.contains('open'));
      });

      /* Esc で閉じる。開閉ボタンへフォーカスを戻します */
      addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && panel.classList.contains('open')) {
          setOpen(false);
          btn.focus();
        }
      });

      /* パネル外のクリックで閉じる */
      document.addEventListener('click', function (e) {
        if (!panel.classList.contains('open')) return;
        if (panel.contains(e.target) || btn.contains(e.target)) return;
        setOpen(false);
      });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
